import type { ModelLead } from '@app/api/Leads/types';

export const patchLeadInList = (
  leads: ModelLead[],
  updatedLead: ModelLead
): ModelLead[] => {
  const leadIndex = leads.findIndex(({ Id }) => Id === updatedLead.Id);

  if (leadIndex === -1) return leads;

  const nextLeads = [...leads];
  nextLeads[leadIndex] = {
    ...leads[leadIndex],
    ...updatedLead,
  };

  return nextLeads;
};
